import { toast } from 'react-toastify'
import React, { useEffect, useState, useContext } from 'react'
import AdminComponent from '../../components/AdminComponent'
import AdminForm from '../../components/AdminForm'
import Table from '../../components/Table';
import { AuthContext } from '../../context/AuthContext';
import { api } from '../../api/axios';
import { tableDateFormate } from '../../utils/dateHelper';
import { Eye, EyeOff, Trash, Pen, KeyRound } from 'lucide-react';
import Modal from '../../components/Modal';
import Select from 'react-select';
import PaginationBar from '../../components/PaginationBar';

const PAGE_SIZE = 20;

const tableHeadingdata = ["#", "Name", "Permission", "Username", "Date", "Action"]
const userPermissionsdata = [
    { value: 'ads', label: 'Ads' },
    { value: 'updates', label: 'Updates' },
    { value: 'feed', label: 'Feed' },
    { value: 'users', label: 'Users' },
    { value: 'breakingnews', label: 'Breaking News' },
    { value: 'polls', label: 'Polls' },
    { value: 'meetings', label: 'Meetings' },
]

export default function Admins() {
    const { loading } = useContext(AuthContext);
    const [adminsData, setAdminsData] = useState([]);
    const [page, setPage] = useState(1);
    const [isResetPasswordModalOpen, setIsResetPasswordModalOpen] = useState(false);
    const [resetPasswordAdminData, setResetPasswordAdminData] = useState({
        id: null,
        username: null,

    });
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editAdminData, setEditAdminData] = useState({
        id: null,
        name: null,
        username: null,
        permission: null,
    });


    useEffect(() => {
        handelGetData();
    }, [loading])

    const handelGetData = async () => {
        try {
            const resposns = await api.get("/admin")
            setAdminsData(resposns.data)
            const permissions = resposns.data[0].permission.join(', ').toUpperCase().toString();

        } catch (error) {
            console.error(error);
        }
    }

    const handeDeleteAdmin = async (id) => {
        if (!window.confirm('Delete this admin? This cannot be undone.')) return;
        try {
            const resposns = await api.delete(`/admin/${id}`)

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Admin Deleted Successfully")
            }

        } catch (error) {
            toast.error("Admin Delete Error")
            console.error(error);
        }
    }

    const handleResetPasswordModalOpen = async (item) => {
        setIsResetPasswordModalOpen(true);
        setResetPasswordAdminData({
            id: item._id,
            username: item.username,
        })

    }

    const handleCloseResetPasswordModal = () => setIsResetPasswordModalOpen(false)

    const handleSubmitResetPasswordForm = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData);
        try {
            const resposns = await api.patch(`/admin/reset-password/${resetPasswordAdminData.id}`,
                { password: data.password })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Password Reset Successfully")
                handleCloseResetPasswordModal();
            }

        } catch (error) {
            toast.error("Password Reset Error")
            console.error(error);
        }
    }

    const handleToggleAdminStatus = async (id, status) => {
        try {
            const resposns = await api.patch(`/admin/active/${id}`,
                { isActive: !status })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Admin Status Updated Successfully")
            }

        } catch (error) {
            toast.error("Admin Status Update Error")
            console.error(error);
        }
    }

    const handleAdminEditModal = (item) => {
        setEditAdminData({
            id: item._id,
            name: item.name,
            username: item.username,
            permission: item.permission,
        })
        setIsEditModalOpen(true);
    }



    return (
        <>
            <AdminComponent>
                <AdminForm />

                <Table
                    tableHeadingdata={tableHeadingdata}>
                    <>
                        {
                            adminsData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map((item, index) => (
                                <tr className="bg-white border-b hover:bg-gray-100 text-gray-900" key={index}>
                                    <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                        {(page - 1) * PAGE_SIZE + index + 1}
                                    </th>
                                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                                        {item.name.toUpperCase().toString()}
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {item.isSuperAdmin ? "Full Access" : item.permission.join(', ').toUpperCase().toString()}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {item.username}
                                    </td>
                                    <td className="px-6 py-4">
                                        {tableDateFormate(item.updatedAt)}
                                    </td>
                                    <td className="px-6 py-4 text-right flex gap-6 justify-center">

                                        <button
                                            disabled={item.username === 'admin'}
                                            onClick={() => handleToggleAdminStatus(item._id, item.isActive)}
                                            className="font-medium text-gray-400 dark:text-gray-400 dark:hover:text-gray-800 hover:text-gray-800">
                                            {item.isActive ? <Eye /> : <EyeOff />}
                                        </button>
                                        <button
                                            onClick={() => handleResetPasswordModalOpen(item)}
                                            className="font-medium text-purple-400 dark:text-purple-400 dark:hover:text-purple-800 hover:text-purple-800"
                                        >
                                            <KeyRound />
                                        </button>
                                        <button
                                            onClick={() => handeDeleteAdmin(item._id)}
                                            disabled={item.username === 'admin'}
                                            className="font-medium text-red-300 dark:text-red-300 dark:hover:text-red-600 hover:text-red-600">
                                            <Trash />
                                        </button>
                                        {/* <button
                                            onClick={() => handleAdminEditModal(item)}
                                            className="font-medium text-green-300 dark:text-greenblue-300 dark:hover:text-green-600 hover:text-green-600">
                                            <Pen />
                                        </button> */}
                                    </td>
                                </tr>
                            ))
                        }
                    </>
                </Table>

                <div className="mt-4">
                    <PaginationBar
                        totalItems={adminsData.length}
                        page={page}
                        pageSize={PAGE_SIZE}
                        onChange={setPage}
                    />
                </div>

                {
                    isResetPasswordModalOpen && <Modal
                        title={"Reset password"}
                        closeModal={handleCloseResetPasswordModal}>
                        <form onSubmit={handleSubmitResetPasswordForm} className='grid grid-cols-6 gap-x-4 gap-y-6'>
                            <div className="col-span-6">
                                <label htmlFor="newpassword" className="block text-sm/6 font-medium text-gray-900">
                                    New Password <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="newpassword"
                                        name="password"
                                        type="text"

                                        required={true}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="col-span-6 flex justify-center">
                                <button
                                    type="submit"
                                    className="rounded-md bg-green-600 w-full px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                >
                                    Update Password
                                </button>
                            </div>
                        </form>
                    </Modal>
                }

                {
                    isEditModalOpen && <Modal
                        title={"Edit Admin Details"}
                        closeModal={() => setIsEditModalOpen(false)}>
                        <form onSubmit={handleSubmitResetPasswordForm} className='grid grid-cols-6 gap-x-4 h-[80dvh] gap-y-6 w-[50rem]'>
                            <div className="col-span-4">
                                <label htmlFor="updatename" className="block text-sm/6 font-medium text-gray-900">
                                    Name <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="updatename"
                                        name="name"
                                        type="text"
                                        defaultValue={editAdminData.name}
                                        required={true}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>

                            <div className="col-span-2">
                                <label htmlFor="updateUsername" className="block text-sm/6 font-medium text-gray-900">
                                    Username <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <input
                                        id="updateUsername"
                                        name="username"
                                        type="text"
                                        defaultValue={editAdminData.name}
                                        required={true}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>

                            <div className="col-span-6">
                                <label htmlFor="updateUsername" className="block text-sm/6 font-medium text-gray-900">
                                    Username <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-3">
                                    <Select
                                        value={userPermissionsdata.find(option => option.value === editAdminData.permission)}
                                        isMulti
                                        name="userPermissions"
                                        options={userPermissionsdata}
                                        // onChange={handelPermission}
                                        className="basic-multi-select"
                                        classNamePrefix="select "
                                    />
                                </div>
                            </div>

                        </form>
                    </Modal>
                }
            </AdminComponent>
        </>
    )
}
